export var IdSoundGroup;
(function (IdSoundGroup) {
    IdSoundGroup["Global"] = "Global";
    IdSoundGroup["Music"] = "Music";
    IdSoundGroup["Sound"] = "Sound";
})(IdSoundGroup || (IdSoundGroup = {}));



//////////////////
// WEBPACK FOOTER
// ./src/utils/sound/IdSoundGroup.ts
// module id = 145
// module chunks = 3